import endpoint from "#src/config/endpoint";
import request from "#src/utils/request";
import { IThreatPolicyItem } from "./types";

interface IThreatPolicyParams {
  action: string | undefined;
  enabled: string | undefined;
  host_ids: string | undefined; // this is actually an array of numbers being joined with ","
  tag_ids: string | undefined; // this is actually an array of numbers being joined with ","
  group: string | undefined;
  source: string | undefined;
}

export async function listThreatPoliciesNoPaging(
  workspaceId: string,
  params: IThreatPolicyParams & { q: string | undefined }
): Promise<IThreatPolicyItem[]> {
  return await request.get<never, IThreatPolicyItem[]>(
    `${endpoint.WORKSPACES}/${workspaceId}/active_responses`,
    { params: { paging: 0, ...params } }
  );
}

export function createThreatPolicy(
  workspaceId: string,
  data: Pick<
    IThreatPolicyItem,
    "group" | "action" | "sources" | "matches" | "description"
  > & { hosts_tags: { id: string; type: string }[] }
) {
  return request.post<never, { id: string }>(
    `${endpoint.WORKSPACES}/${workspaceId}/active_responses`,
    data
  );
}

export function updateThreatPolicy(
  workspaceId: string,
  policyId: string,
  data: Pick<
    IThreatPolicyItem,
    "group" | "action" | "sources" | "matches" | "description"
  > & { hosts_tags: { id: string; type: string }[] }
) {
  return request.put<never, { id: string }>(
    `${endpoint.WORKSPACES}/${workspaceId}/active_responses/${policyId}`,
    data
  );
}

export function updateEnabledThreatPolicy(
  workspaceId: string,
  policyId: string,
  data: Pick<IThreatPolicyItem, "enabled">
) {
  return request.put<never, { id: string }>(
    `${endpoint.WORKSPACES}/${workspaceId}/active_responses/${policyId}/enabled`,
    data
  );
}

export async function deleteThreatPolicy(
  workspaceId: string,
  controlId: string
) {
  return request.delete<never>(
    `${endpoint.WORKSPACES}/${workspaceId}/active_responses/${controlId}`
  );
}

export async function changeThreatPolicyPriority(
  workspaceId: string,
  data: { id: string; swap_id: string | null }
) {
  return request.post<never, { success: boolean }>(
    `${endpoint.WORKSPACES}/${workspaceId}/active_responses/priority`,
    data
  );
}
